import React, { useEffect, useMemo, useRef, useState } from "react";
import SC from "./style";
import { useSelector } from "react-redux";
import { apiGet, apiPost } from "api/callApi";
import TextFilterDropdown from "components/AdvancedSearchComponent/TextFilterDropdown";
import MultiSelectDropdown from "components/AdvancedSearchComponent/MultiSelectDropdown";
import CreatedOnDropdown from "components/AdvancedSearchComponent/CreatedOnDropdown";
import MoreFilterDropdown from "components/AdvancedSearchComponent/MoreFilterDropdown";
import SizeFilterDropdown from "components/AdvancedSearchComponent/SizeFilterDropdown";
import { jobTypes, projectType, queryTypes } from "utils/lookUpTable";
import RevisionFilterDropdown from "components/AdvancedSearchComponent/RevisionFilterDropdown";
import SaveFilterModal from "components/AdvancedSearchComponent/SaveFilterModal";
import SavedFilterDropdown from "components/AdvancedSearchComponent/SavedFilterDropdown";
import { fileTypeOptions } from "utils/optionData/utils";
import { Button } from "@InnoUI/";
import theme from "@theme/";
import FileTable from "./FileTable";
import FileListShimmer from "./FileListShimmer";
import { useSearchParams } from "react-router-dom";
import InnoIcons from "@InnoIcons/";
import InteractiveSearchUI from "../InteractiveSearchUI";
import { AIServices } from "utils/helper";

const FileSearchInterface = (props) => {
  const { activeTab, setActiveTab = () => {}, filterSessionKey } = props;
  const [hideFilterOptions, setHideFilterOptions] = useState(false);
  const [data, setData] = useState([]);
  const [openModalView, setOpenModalView] = useState(false);
  const [savedFilters, setSavedFilters] = useState([]);
  const [activeRelatedDropdowns, setActiveRelatedDropdowns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchKey, setSearchKey] = useState("");
  const [documentData, setDocumentData] = useState([]);
  const [record, setTotalRecord] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const occupantsID = searchParams.get("projectId");
  const [chatUI, setChatUI] = useState(false);
  const [chatData, setChatData] = useState([]);
  const accessControlData = useSelector(
    (state) => state?.accessControlData?.data || [],
  );

  // This just controls the checkboxes in MoreFilterDropdown
  const [moreFilterSelectedIds, setMoreFilterSelectedIds] = useState([]);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );

  // Initialize selected filter ID
  const [selectedFilterId, setSelectedFilterId] = useState(() => {
    const saved = sessionStorage.getItem(filterSessionKey);
    if (saved) {
      const parsed = JSON.parse(saved);
      return parsed.selectedFilterId || null;
    }
    return null;
  });

  console.log("selectedFilterId", selectedFilterId);

  const optionsMoreFilter = [
    { id: "1", label: "Original File Name", related: "TextFilterDropdown" },
    { id: "2", label: "Updated By", related: "UpdatedByTextFilterDropdown" },
    { id: "3", label: "Revision", related: "RevisionFilterDropdown" },
    { id: "4", label: "Updated Date", related: "CreatedOnDropdown" },
    { id: "5", label: "Point Id", related: "TextFilterPointIdDropdown" },
  ];

  const RevisionRadioOptions = [
    { key: "latest", label: "Latest Revision" },
    { key: "all", label: "All Revisions" },
  ];

  const defaultFilters = {
    occupants: { header: "equals", selectedIds: [] },
    createdBy: { header: "equals", selectedIds: [] },
    lastUpdateBy: { header: "equals", selectedIds: [] },
    fileTypes: { header: "equals", selectedIds: [] },

    fileName: { header: "equals", value: "" },
    pointId: { header: "equals", value: "" },
    submissionNote: { header: "equals", value: "" },
    subject: { header: "equals", value: "" },
    folderName: { header: "equals", value: "" },

    createdOn: {
      header: "withinLast",
      value: {
        number: "",
        unit: "",
      },
    },
    lastUpdate: null,
    fileSize: { header: "equals", value: "" },
    revision: { value: "" },
    textfields: "",
    rawJQL: [],
  };

  const [tabFilters, setTabFilters] = useState(() => {
    const saved = sessionStorage.getItem(filterSessionKey);
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        ...{
          1: defaultFilters,
        },
        [parsed.activeTab]: parsed.filters || defaultFilters,
      };
    }
    return {
      1: defaultFilters,
    };
  });

  const [filters, setFilters] = useState(() => {
    const saved = sessionStorage.getItem(filterSessionKey);
    if (saved) {
      const parsed = JSON.parse(saved);
      return parsed.filters || defaultFilters;
    }
    return defaultFilters;
  });

  const [searchText, setSearchText] = useState(() => {
    const saved = sessionStorage.getItem(filterSessionKey);
    if (saved) {
      const parsed = JSON.parse(saved);
      return parsed.searchText || "";
    }
    return "";
  });

  const getAppliedFilterCount = (filters) => {
    console.log(filters, "filters");

    let count = 0;

    // 1️⃣ Multi-select filters
    const multiSelectKeys = [
      "occupants",
      "createdBy",
      "lastUpdateBy",
      "fileTypes",
    ];
    multiSelectKeys.forEach((key) => {
      if (filters[key]?.selectedIds?.length > 0) count++;
    });

    // 2️⃣ Text filters
    const textKeys = [
      "fileName",
      "pointId",
      "submissionNote",
      "subject",
      "folderName",
    ];
    textKeys.forEach((key) => {
      const filter = filters[key];

      if (!filter) return;

      const value = filter.value;
      const header = filter.header;

      // mark special empty/not-empty modes as active
      const isEmptyMode =
        header === "is-empty" ||
        header === "is-not-empty" ||
        value === "__IS_EMPTY__" ||
        value === "__IS_NOT_EMPTY__";

      if (isEmptyMode) {
        count++;
        return;
      }

      // normal text value
      if (value && value.trim() !== "") {
        count++;
      }
    });

    // 3️⃣ Date filters
    const dateKeys = ["createdOn", "lastUpdate"];
    dateKeys.forEach((key) => {
      const val = filters[key];
      if (
        val &&
        ((val.value?.number && val.value?.unit) || // withinLast/moreThan
          (val.value?.[0] && val.value?.[1])) // inRange
      ) {
        count++;
      }
    });

    // 4️⃣ Revision filter (only count if not empty)
    if (filters.revision?.value) {
      count++;
    }

    // 5️⃣ File size filter
    if (filters.fileSize?.value) count++;

    // 6️⃣ Textfields quick search
    // if (filters.textfields?.trim()) count++;

    return count;
  };

  const appliedFilterCount = useMemo(
    () => getAppliedFilterCount(filters),
    [filters],
  );

  useEffect(() => {
    if (appliedFilterCount > 0) {
      setHideFilterOptions(true);
    }
  }, [appliedFilterCount]);

  // Save filters in sessionStorage whenever they change
  useEffect(() => {
    const filterToStore = {
      filters,
      activeTab,
      searchText,
      selectedFilterId, // ← include this!
    };
    sessionStorage.setItem(filterSessionKey, JSON.stringify(filterToStore));
  }, [filters, activeTab, searchText, selectedFilterId]);

  useEffect(() => {
    const savedFilter = sessionStorage.getItem(filterSessionKey);
    if (savedFilter) {
      const parsed = JSON.parse(savedFilter);

      // Set state
      setFilters(parsed.filters || defaultFilters);
      setActiveTab(parsed.activeTab || "1");
      setSearchText(parsed.searchText || "");

      // Update tabFilters
      setTabFilters((prev) => ({
        ...prev,
        [parsed.activeTab || "1"]: parsed.filters || defaultFilters,
      }));
    }
  }, []);

  useEffect(() => {
    // Combine all text filter values for highlighting
    const textFilters = [
      filters.fileName?.value,
      filters.pointId?.value,
      filters.submissionNote?.value,
      filters.subject?.value,
      filters.folderName?.value,
      filters.textfields,
    ].filter(Boolean); // remove empty strings or nulls

    console.log(textFilters, "textFilters");

    const combinedSearchKey = textFilters.join(" ");
    setSearchKey(combinedSearchKey);
  }, [filters, searchText]);

  const fetchSavedFilters = async (tabId, type, occupantsID) => {
    if (!currentProject?.id) return;

    try {
      const payload = {
        projectId: currentProject.id,
        type: tabId, // 1=file, 2=journal, 3=occupant
      };
      const response = await apiPost("/v1/getfilters", payload, false);
      if (response?.data) {
        setSavedFilters(response.data);

        const sessionFilter = sessionStorage.getItem(filterSessionKey);
        let applyBackendDefault = false;

        if (!sessionFilter) {
          // Session empty → apply backend default
          applyBackendDefault = true;
        } else {
          const parsed = JSON.parse(sessionFilter);
          const sessionFilters = parsed.filters || {};
          const isSameAsDefault =
            JSON.stringify(sessionFilters) === JSON.stringify(defaultFilters);

          if (isSameAsDefault) {
            // Session has only default filters → backend default should apply
            applyBackendDefault = true;
          }
        }

        if (applyBackendDefault) {
          // 🟢 Backend default found → apply AS-IS (no occupant change)
          const defaultFilter = response.data.find((f) => f.isDefault);

          if (defaultFilter) {
            applyFilter(defaultFilter);
          } else {
            // ⚠️ No backend default → apply frontend default and inject occupantsID if type=1
            const modifiedDefault = {
              filters: {
                ...defaultFilters,
                ...(type == 1 && occupantsID
                  ? {
                      occupants: {
                        ...defaultFilters.occupants,
                        selectedIds: [occupantsID],
                      },
                    }
                  : {}),
              },
            };
            applyFilter(modifiedDefault);
          }
        } else {
          // 🟡 Session exists → update occupants if type=1
          const parsed = JSON.parse(sessionFilter);
          let updatedFilters = { ...parsed.filters };

          if (type == 1 && occupantsID) {
            updatedFilters = {
              ...updatedFilters,
              occupants: {
                ...updatedFilters.occupants,
                selectedIds: [occupantsID], // always replace with current occupant
              },
            };
          }

          const newSession = { ...parsed, filters: updatedFilters };
          setFilters(updatedFilters);
          sessionStorage.setItem(filterSessionKey, JSON.stringify(newSession));
        }
      }
    } catch (error) {
      console.error("Error fetching saved filters:", error);
      setSavedFilters([]);
    }
  };
  // Update applyFilter

  useEffect(() => {
    fetchSavedFilters(activeTab, type, occupantsID);
  }, [currentProject?.id, activeTab]);

  useEffect(() => {
    if (type == 1 && occupantsID) {
      fetchSavedFilters(activeTab, type, occupantsID);
    }
  }, [occupantsID]);

  const applyFilter = (filter) => {
    if (!filter) {
      sessionStorage.removeItem(filterSessionKey);
      setFilters(defaultFilters);
      setSelectedFilterId(null);
      setTabFilters((prev) => ({
        ...prev,
        [activeTab]: defaultFilters,
      }));
      setSearchText("");
      setCurrentPage(1);
      return;
    }

    const newFilters = filter.filters || {};
    setFilters(newFilters);
    setSelectedFilterId(filter.id); // update selected filter
    setTabFilters((prev) => ({
      ...prev,
      [activeTab]: newFilters,
    }));
    setSearchText(newFilters.textfields || "");
    setCurrentPage(1);

    // Save to session
    const filterToStore = {
      filters: newFilters,
      activeTab,
      searchText: newFilters.textfields || "",
      selectedFilterId: filter.id, // store applied filter ID
    };
    sessionStorage.setItem(filterSessionKey, JSON.stringify(filterToStore));
  };

  // Callback from MoreFilterDropdown
  const handleOpenRelatedDropdown = (relatedArray) => {
    setActiveRelatedDropdowns(relatedArray || []);

    const unselected = [
      "TextFilterDropdown",
      "RevisionFilterDropdown",
      "CreatedOnDropdown",
      "UpdatedByTextFilterDropdown",
      "TextFilterPointIdDropdown",
    ].filter((d) => !relatedArray.includes(d));

    unselected.forEach((dropdown) => {
      if (dropdown === "TextFilterDropdown") {
        updateFilter("fileName", { value: "" });
        setMoreFilterSelectedIds((prev) => prev.filter((id) => id !== "1"));
      }
      if (dropdown === "TextFilterPointIdDropdown") {
        updateFilter("pointId", { value: "" });
        setMoreFilterSelectedIds((prev) => prev.filter((id) => id !== "5"));
      }
      if (dropdown === "RevisionFilterDropdown") {
        updateFilter("revision", { value: "" });
        setMoreFilterSelectedIds((prev) => prev.filter((id) => id !== "3"));
      }
      if (dropdown === "CreatedOnDropdown") {
        updateFilter("lastUpdate", "");
        setMoreFilterSelectedIds((prev) => prev.filter((id) => id !== "4"));
      }
      if (dropdown === "UpdatedByTextFilterDropdown") {
        updateFilter("lastUpdateBy", { selectedIds: [] });
        setMoreFilterSelectedIds((prev) => prev.filter((id) => id !== "2"));
      }
    });
  };

  const handleClear = (save = true) => {
    // 🟢 Create a copy of default filters to avoid mutation
    let newFilters = { ...defaultFilters };

    // 🟢 If type is 1, inject current occupant ID
    if (type == 1 && occupantsID) {
      newFilters = {
        ...defaultFilters,
        occupants: {
          ...defaultFilters.occupants,
          selectedIds: [occupantsID],
        },
      };
    }

    // Reset filters to new defaults
    setFilters(newFilters);
    // Clear checkboxes and dropdown states
    setMoreFilterSelectedIds([]);
    setActiveRelatedDropdowns([]);
    // Clear search text
    setSearchText("");
    setChatData([]);
    // Clear selected filter
    setSelectedFilterId(null);
    // Reset tabFilters for current tab
    setTabFilters((prev) => ({
      ...prev,
      [activeTab]: defaultFilters,
    }));
    // Remove session storage entry
    if (save) {
      sessionStorage.removeItem(filterSessionKey);
    }
    // Reset pagination
    setCurrentPage(1);
  };
  const handleClearIntractiveSearch = (save = true) => {
    // 🟢 Create a copy of default filters to avoid mutation
    let newFilters = { ...defaultFilters };

    // Reset filters to new defaults
    setFilters(newFilters);

    // Clear checkboxes and dropdown states
    setMoreFilterSelectedIds([]);
    setActiveRelatedDropdowns([]);
    // Clear search text
    setSearchText("");
    setChatData([]);
    // Clear selected filter
    setSelectedFilterId(null);
    // Reset tabFilters for current tab
    setTabFilters((prev) => ({
      ...prev,
      [activeTab]: defaultFilters,
    }));
    // Remove session storage entry
    if (save) {
      sessionStorage.removeItem(filterSessionKey);
    }
    // Reset pagination
    setCurrentPage(1);
  };

  // Debounce effect
  useEffect(() => {
    // 🧠 If searchText is empty → reset filters immediately
    if (searchText.trim() === "") {
      setFilters((prev) => ({
        ...prev,
        textfields: "",
      }));
      setCurrentPage(1);
      return; // skip debounce logic
    }

    // 🕒 Otherwise run debounce when user types
    const handler = setTimeout(() => {
      setFilters((prev) => ({
        ...prev,
        textfields: searchText,
      }));
      setCurrentPage(1);
    }, 500);

    // 🧹 Cleanup debounce
    return () => clearTimeout(handler);
  }, [searchText]);

  const openSaveFilterModal = () => setOpenModalView(true);

  const tabs = [
    { id: "1", value: "Files" },
    { id: "2", value: "Journal" },
    { id: "3", value: "Occupant" },
  ];

  const getAddressBookData = async () => {
    try {
      const url = `/v1/addressbook/${currentProject?.id}/${projectType.property}`;
      const response = await apiGet(url);
      const mergedData = response.data;
      setData(mergedData);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getAddressBookData();
  }, [currentProject?.id]);

  const occupantOptionData = useSelector((state) =>
    Array.isArray(state?.occupantOption?.data) ? state.occupantOption.data : [],
  );

  // Convert occupant data to {id, label} format for MainDropdown
  const options = occupantOptionData.map((item) => ({
    id: item.id,
    label: `${item.occupantName} (${item.occupantNo})`,
  }));

  const userOptions = data.map((item) => ({
    id: item.id,
    label: `${item.fullName}`,
  }));

  const handleAdvancedOptions = () => setHideFilterOptions(!hideFilterOptions);

  const handleIntractiveSearch = () => {
    setChatUI(!chatUI);
    setHideFilterOptions(false);
    handleClearIntractiveSearch();
  };

  const updateFilter = (filterKey, updates) => {
    setFilters((prev) => {
      const updatedFilters = updates
        ? { ...prev[filterKey], ...updates }
        : null;

      setTabFilters((prevTabs) => ({
        ...prevTabs,
        [activeTab]: {
          ...prevTabs[activeTab],
          [filterKey]: updatedFilters,
        },
      }));

      return { ...prev, [filterKey]: updatedFilters };
    });
  };

  // Helper to map dropdown ID to relatedDropdown key
  const getDropdownKeyById = (id) => {
    const map = {
      1: "TextFilterDropdown",
      2: "UpdatedByTextFilterDropdown",
      3: "RevisionFilterDropdown",
      4: "CreatedOnDropdown",
      5: "TextFilterPointIdDropdown",
    };
    return map[id];
  };

  useEffect(() => {
    // Restore saved filters for the selected tab
    const saved = tabFilters[activeTab] || filters;
    setFilters(saved);
    // Fetch saved filters from backend
    fetchSavedFilters(activeTab, type, occupantsID);
    // Reset page
    setCurrentPage(1);
  }, [activeTab]);

  const getFilterData = async () => {
    try {
      setIsLoading(true);
      const searchQuery = buildSearchQuery() || "";
      if (!currentProject?.id) {
        setDocumentData([]);
        setTotalRecord(0);
        return;
      }
      const payload = {
        projectId: currentProject?.id,
        searchQuery,
        pageSize,
        pageNo: currentPage,
        filesIds: chatData?.files || [],
      };
      const response = await apiPost(`/v1/file/advancedsearch`, payload, false);
      setDocumentData(response?.data || []);
      setTotalRecord(response?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching document data:", error);
      setDocumentData([]);
      setTotalRecord(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFilterData();
  }, [filters, chatData, pageSize, currentPage]);

  const buildSearchQuery = () => {
    const conditions = [];

    // Multi-select filters
    const multiSelectFilters = [
      {
        field: "projectId",
        header: filters?.occupants?.header,
        selectedIds: filters?.occupants?.selectedIds,
      },
      {
        field: "createdBy",
        header: filters?.createdBy?.header,
        selectedIds: filters?.createdBy?.selectedIds,
      },
      {
        field: "lastUpdateBy",
        header: filters?.lastUpdateBy?.header,
        selectedIds: filters?.lastUpdateBy?.selectedIds,
      },
      {
        field: "fileType",
        header: filters?.fileTypes?.header,
        selectedIds: filters?.fileTypes?.selectedIds,
      },
      // {
      //   field: "id",
      //   header: "equals",
      //   selectedIds: chatData?.files,
      // },
    ];

    multiSelectFilters.forEach(({ field, header, selectedIds }) => {
      if (!selectedIds?.length) return;
      const operator = header === "equals" ? "IN" : "NOT IN";
      conditions.push(
        `${field} ${operator} (${selectedIds
          ?.map((id) => `"${id}"`)
          .join(",")})`,
      );
    });

    // markers used by the dropdown component when user selects IS EMPTY / IS NOT EMPTY
    const IS_EMPTY_MARKER = "__IS_EMPTY__";
    const IS_NOT_EMPTY_MARKER = "__IS_NOT_EMPTY__";

    const addTextCondition = (field, value, header) => {
      // handle explicit markers first
      if (value === IS_EMPTY_MARKER || header === "is-empty") {
        // search for NULL OR trimmed empty string
        conditions.push(`${field} IS EMPTY`);
        return;
      }
      if (value === IS_NOT_EMPTY_MARKER || header === "is-not-empty") {
        conditions.push(`${field} IS NOT EMPTY`);
        return;
      }

      // if no value, skip (normal behavior)
      if (!value || String(value).trim() === "") return;

      // escape double-quotes inside value
      const safeValue = String(value).replace(/"/g, '\\"');

      switch (header) {
        case "equals":
          conditions.push(`${field} = "${safeValue}"`);
          break;
        case "not-equals":
          conditions.push(`${field} != "${safeValue}"`);
          break;
        case "contains":
          conditions.push(`${field} ~ "${safeValue}"`);
          break;
        case "startsWith":
          conditions.push(`${field} STARTS WITH "${safeValue}"`);
          break;
        case "endsWith":
          conditions.push(`${field} ENDS WITH "${safeValue}"`);
          break;
        default:
          break;
      }
    };

    // build textFilters array (unchanged)
    const textFilters = [
      { field: "fileName", ...filters.fileName },
      { field: "pointId", ...filters.pointId },
      { field: "note", ...filters.submissionNote },
      { field: "subject", ...filters.subject },
      { field: "folderName", ...filters.folderName },
    ];

    // apply them
    textFilters.forEach(({ field, value, header }) =>
      addTextCondition(field, value, header),
    );

    // TextFields quick search
    if (filters.textfields && filters.textfields.trim() !== "") {
      conditions.push(`textfields ~ "${filters.textfields.trim()}"`);
    }

    // --- Date filters: CreatedOn & LastUpdate ---
    ["createdOn", "lastUpdate"].forEach((field) => {
      const val = filters[field];
      if (!val) return; // skip if null

      let conditionStr = "";

      switch (val.header) {
        case "withinLast":
          if (val.value?.number) {
            conditionStr = `${field} last ${val.value.number} ${val.value.unit}`;
          }
          break;

        case "moreThan":
          if (val.value?.number) {
            conditionStr = `${field} moreThan ${val.value.number} ${val.value.unit}`;
          }
          break;

        case "inRange":
          if (val.value?.[0] && val.value?.[1]) {
            conditionStr = `${field} inRange "${val.value[0]}" "${val.value[1]}"`;
          }
          break;

        default:
          break;
      }

      if (conditionStr) conditions.push(conditionStr);
    });

    // --- Revision filter ---
    if (filters.revision) {
      const revHeader = filters.revision.value;
      switch (revHeader) {
        case "latest":
          conditions.push("revision = latest");
          break;
        case "all":
          conditions.push("revision = all");
          break;
        default:
          break;
      }
    }

    // --- revision filter ---
    // if (filters.revision) {
    //   conditions.push(`revision = ${filters.revision.value}`);
    // }

    // --- File Size filter (numeric KB/MB/GB) ---
    if (
      filters?.fileSize?.value !== null &&
      filters?.fileSize?.value !== "" &&
      Number(filters?.fileSize?.value) > 0
    ) {
      let operator = "="; // default
      if (filters?.fileSize?.header === "not-equals") operator = "!=";
      else if (filters?.fileSize?.header === "lessThanEqual") operator = "<=";
      else if (filters?.fileSize?.header === "greaterThanEqual")
        operator = ">=";

      conditions.push(`fileSize ${operator} ${filters?.fileSize?.value}`);
    }

    // Additional advanced filters: allow raw JQL conditions from frontend
    if (filters.rawJQL && filters.rawJQL.length) {
      conditions.push(...filters.rawJQL);
    }

    return conditions.join(" AND ");
  };

  const deriveSelectedIdsFromFilters = () => {
    const ids = [];
    if (filters.fileName?.value) ids.push("1"); // TextFilterDropdown
    if (filters.pointId?.value) ids.push("5"); // TextFilterPointIdDropdown
    if (filters.lastUpdateBy?.selectedIds?.length > 0) ids.push("2"); // UpdatedByTextFilterDropdown
    if (filters.revision?.value) ids.push("3"); // RevisionFilterDropdown
    if (filters.lastUpdate) ids.push("4"); // CreatedOnDropdown
    return ids;
  };

  // Sync checkboxes when filters are first loaded or a filter is applied
  useEffect(() => {
    const selectedIdsFromFilters = deriveSelectedIdsFromFilters();
    setMoreFilterSelectedIds(selectedIdsFromFilters);

    const relatedDropdowns = selectedIdsFromFilters.map(getDropdownKeyById);
    setActiveRelatedDropdowns(relatedDropdowns);
  }, [selectedFilterId]); // only when a filter is applied/loaded

  const handleMoreFilterChange = (ids) => {
    // Determine which IDs were removed
    const removedIds = moreFilterSelectedIds.filter((id) => !ids.includes(id));

    removedIds.forEach((id) => {
      const dropdownKey = getDropdownKeyById(id);
      if (dropdownKey === "TextFilterDropdown") {
        updateFilter("fileName", { value: "" }, "1");
      } else if (dropdownKey === "TextFilterPointIdDropdown") {
        updateFilter("pointId", { value: "" }, "5");
      } else if (dropdownKey === "RevisionFilterDropdown") {
        updateFilter("revision", { value: "" }, "3");
      } else if (dropdownKey === "CreatedOnDropdown") {
        updateFilter("lastUpdate", null, "4");
      } else if (dropdownKey === "UpdatedByTextFilterDropdown") {
        updateFilter("lastUpdateBy", { selectedIds: [] }, "2");
      }
    });

    // Update state
    setMoreFilterSelectedIds(ids);
    setActiveRelatedDropdowns(ids.map(getDropdownKeyById));
  };

  return (
    <>
      <SC.Container>
        {/* Search Row */}
        <SC.SearchRow>
          <SC.LeftControls>
            {!chatUI && (
              <>
                <SC.InputContiner>
                  <SC.SearchIcon />
                  <SC.InputStyle
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value.trimStart())}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && searchText.trim() !== "") {
                        getFilterData();
                      }
                    }}
                  />
                </SC.InputContiner>

                <SC.AdvancedOptionsButton onClick={handleAdvancedOptions}>
                  Advanced Options
                  {appliedFilterCount > 0 && (
                    <SC.Badge>{appliedFilterCount}</SC.Badge>
                  )}
                  {hideFilterOptions ? (
                    <InnoIcons.KeyboardArrowUpIcon />
                  ) : (
                    <InnoIcons.KeyboardArrowDownIcon />
                  )}
                </SC.AdvancedOptionsButton>

                {AIServices() &&
                  accessControlData.canAccessInteractiveSearch == 1 && (
                    <Button
                      caption={"Interactive Search"}
                      onClick={handleIntractiveSearch}
                      color="black"
                      fontSize="12px"
                      leftIcon={
                        <InnoIcons.AutoAwesomeIcon
                          sx={{
                            fontSize: "20px",
                            color: theme.colors.themeColor,
                          }}
                        />
                      }
                      style={{
                        background: "white",
                        color: theme.colors.white,
                        // minWidth: "150px",
                        height: "40px",
                        borderRadius: "6px",
                        border: `1px solid ${theme.colors.themeColor}`,
                      }}
                    />
                  )}
              </>
            )}
          </SC.LeftControls>

          <SC.SavedFilterContainer>
            {hideFilterOptions && savedFilters.length > 0 && (
              <SavedFilterDropdown
                label=""
                options={savedFilters}
                selectedId={selectedFilterId}
                onSelectionChange={(filter) => {
                  applyFilter(filter);
                  setSelectedFilterId(filter.id);
                }}
                handleClear={() => {
                  applyFilter(null);
                  setSelectedFilterId(null);
                  handleClear(false);
                }}
              />
            )}
          </SC.SavedFilterContainer>
        </SC.SearchRow>

        {/* Advanced Filter Section */}

        {hideFilterOptions && (
          <SC.FilterSection>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // marginBottom: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <SC.FilterRow>
                  <SC.FilterTitle>Advanced Filter</SC.FilterTitle>
                  <MultiSelectDropdown
                    label="Occupant"
                    headerOptionsValueName={"Occupant"} // e.g., equals / not-equals
                    selectedHeaderId={filters?.occupants?.header}
                    onHeaderChange={(header) =>
                      updateFilter("occupants", { header })
                    }
                    options={options} // array of { id, label }
                    selectedIds={filters?.occupants?.selectedIds}
                    onSelectionChange={(selectedIds) =>
                      updateFilter("occupants", { selectedIds })
                    }
                  />

                  <TextFilterDropdown
                    label="File Name"
                    selectedHeaderId={filters?.subject?.header}
                    value={filters?.subject?.value}
                    onHeaderChange={(header) =>
                      updateFilter("subject", { header })
                    }
                    onUpdate={({ headerId, value }) =>
                      updateFilter("subject", { header: headerId, value })
                    }
                  />

                  <CreatedOnDropdown
                    label="Created"
                    field="createdOn"
                    value={filters.createdOn}
                    onUpdate={(value) => updateFilter("createdOn", value)}
                  />
                  <MultiSelectDropdown
                    label="File Type"
                    selectedHeaderId={filters?.fileTypes?.header}
                    headerOptionsValueName={"File Type"}
                    onHeaderChange={(header) =>
                      updateFilter("fileTypes", { header })
                    }
                    options={fileTypeOptions}
                    selectedIds={filters?.fileTypes?.selectedIds}
                    onSelectionChange={(selectedIds) =>
                      updateFilter("fileTypes", { selectedIds })
                    }
                  />

                  <SizeFilterDropdown
                    label="File Size"
                    selectedHeaderId={filters?.fileSize?.header}
                    headerOptionsValueName="File Size"
                    onHeaderChange={(header) =>
                      updateFilter("fileSize", { header })
                    }
                    selectedValue={filters?.fileSize?.value || ""}
                    onValueChange={(valueInMB) =>
                      updateFilter("fileSize", { value: valueInMB })
                    }
                  />

                  <TextFilterDropdown
                    label="Document Summary"
                    headerOptionsValuename={"Document Summary"}
                    selectedHeaderId={filters?.submissionNote?.header}
                    value={filters?.submissionNote?.value}
                    onHeaderChange={(header) =>
                      updateFilter("submissionNote", { header })
                    }
                    onUpdate={({ headerId, value }) =>
                      updateFilter("submissionNote", {
                        header: headerId,
                        value,
                      })
                    }
                    isEmptyOption={true}
                  />

                  <MultiSelectDropdown
                    label="Created By"
                    headerOptionsValueName={"Created By"}
                    selectedHeaderId={filters?.createdBy?.header}
                    onHeaderChange={(header) =>
                      updateFilter("createdBy", { header })
                    }
                    options={userOptions}
                    selectedIds={filters?.createdBy?.selectedIds}
                    onSelectionChange={(selectedIds) =>
                      updateFilter("createdBy", { selectedIds })
                    }
                  />

                  <TextFilterDropdown
                    label="Folder Name"
                    headerOptionsValuename={"Folder Name"}
                    selectedHeaderId={filters?.folderName?.header}
                    value={filters?.folderName?.value}
                    onHeaderChange={(header) =>
                      updateFilter("folderName", { header })
                    }
                    onUpdate={({ headerId, value }) =>
                      updateFilter("folderName", { header: headerId, value })
                    }
                  />

                  {/* {(activeRelatedDropdowns || []).includes(
                    "TextFilterPointIdDropdown",
                  ) && ( */}
                  <TextFilterDropdown
                    label="Ingested"
                    headerOptionsValuename={"Ingested"}
                    selectedHeaderId={filters?.pointId?.header}
                    value={filters?.pointId?.value}
                    onHeaderChange={(header) =>
                      updateFilter("pointId", { header })
                    }
                    onUpdate={({ headerId, value }) =>
                      updateFilter("pointId", { header: headerId, value }, "1")
                    }
                    isEmptyOption={true}
                    pointIdOption={true}
                  />
                  {/* )} */}

                  <MoreFilterDropdown
                    label="More Filter"
                    selectedIds={moreFilterSelectedIds}
                    onSelectionChange={handleMoreFilterChange}
                    onOpenRelatedDropdown={handleOpenRelatedDropdown}
                    options={optionsMoreFilter}
                  />

                  {(activeRelatedDropdowns || []).includes(
                    "RevisionFilterDropdown",
                  ) && (
                    <RevisionFilterDropdown
                      label="Revision"
                      value={filters?.revision?.value}
                      onUpdate={(value) =>
                        updateFilter("revision", { value: value || "" }, "3")
                      }
                      radioOptions={RevisionRadioOptions}
                    />
                  )}

                  {(activeRelatedDropdowns || []).includes(
                    "TextFilterDropdown",
                  ) && (
                    <TextFilterDropdown
                      label="Original File Name"
                      headerOptionsValuename={"Original File Name"}
                      selectedHeaderId={filters?.fileName?.header}
                      value={filters?.fileName?.value}
                      onHeaderChange={(header) =>
                        updateFilter("fileName", { header })
                      }
                      onUpdate={({ headerId, value }) =>
                        updateFilter(
                          "fileName",
                          { header: headerId, value },
                          "1",
                        )
                      }
                    />
                  )}

                  {(activeRelatedDropdowns || []).includes(
                    "CreatedOnDropdown",
                  ) && (
                    <CreatedOnDropdown
                      label="Updated Date"
                      field="lastUpdate"
                      value={filters.lastUpdate}
                      onUpdate={(value) =>
                        updateFilter("lastUpdate", value, "4")
                      }
                    />
                  )}

                  {activeRelatedDropdowns.includes(
                    "UpdatedByTextFilterDropdown",
                  ) && (
                    <MultiSelectDropdown
                      label="Updated By"
                      headerOptionsValueName={"Updated By"}
                      selectedHeaderId={filters?.lastUpdateBy?.header}
                      onHeaderChange={(header) =>
                        updateFilter("lastUpdateBy", { header })
                      }
                      options={userOptions}
                      selectedIds={filters?.lastUpdateBy?.selectedIds}
                      onSelectionChange={(selectedIds) =>
                        updateFilter("lastUpdateBy", { selectedIds }, "2")
                      }
                    />
                  )}

                  <SC.FilterActions>
                    <Button
                      caption="Clear Filter"
                      onClick={handleClear}
                      fontSize="12px"
                      style={{
                        background: theme.colors.cancelButton,
                        color: theme.colors.white,
                        minWidth: "90px",
                        borderRadius: "5px",
                        height: "35px",
                        fontSize: "12px",
                      }}
                    />
                    <Button
                      caption={"Save Filter"}
                      onClick={openSaveFilterModal}
                      color="white"
                      fontSize="12px"
                      style={{
                        background: theme.gradient.themeGradient,
                        color: theme.colors.white,
                        minWidth: "90px",
                        height: "35px",
                        borderRadius: "5px",
                      }}
                    />
                  </SC.FilterActions>
                </SC.FilterRow>
              </div>

              {/* Collapse Filters */}
            </div>
            {/* <SC.CornerIcon onClick={() => setHideFilterOptions(false)}>
              <InnoIcons.KeyboardArrowDownIcon />
            </SC.CornerIcon> */}
          </SC.FilterSection>
        )}
      </SC.Container>

      {/* <div style={{ display: "flex", height: "100%", width: "100%" }}> */}
      <div
        style={{
          display: "flex",
          flexDirection: chatUI && window.innerWidth <= 768 ? "column" : "row",
          height: "100%",
          width: "100%",
          position: "relative",
        }}
      >
        {/* Left side file table */}
        {isLoading ? (
          <div style={{ flex: chatUI ? "0 0 67%" : "100%", minWidth: 0 }}>
            <FileListShimmer />
          </div>
        ) : (
          <div
            // style={{
            //   flex: chatUI ? "0 0 67%" : "100%",
            //   height: "100%",
            //   overflowY: "auto",
            //   overflowX: "hidden",
            //   minWidth: 0,
            // }}

            style={{
              flex: chatUI && window.innerWidth > 768 ? "0 0 67%" : "1 1 auto",
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              minWidth: 0,
            }}
          >
            <FileTable
              documentData={documentData}
              searchKey={searchKey}
              setPageSize={setPageSize}
              currentPage={currentPage}
              pageSize={pageSize}
              setCurrentPage={setCurrentPage}
              record={record}
              chatUI={chatUI}
            />
          </div>
        )}

        {/* Right side Chat — always visible */}
        {chatUI && (
          <div
            // style={{
            //   flex: "0 0 33%", // fixed width ratio
            //   minWidth: 0, // 🔥 KEY FIX
            //   maxWidth: "33%", // hard cap
            //   height: "100%",
            //   borderLeft: "1px solid #eee",
            //   position: "sticky",
            //   top: 120,
            //   overflow: "hidden", // prevent spill
            // }}

            style={{
              flex: window.innerWidth > 768 ? "0 0 33%" : "1 1 auto",
              width: window.innerWidth > 768 ? "33%" : "100%",
              height: window.innerWidth > 768 ? "100%" : "100vh",
              position: window.innerWidth > 768 ? "sticky" : "fixed",
              bottom: window.innerWidth > 768 ? "auto" : 0,
              right: 0,
              top: window.innerWidth > 768 ? 120 : 0,
              zIndex: 20,
              background: "#f6f6f6",
              borderLeft: window.innerWidth > 768 ? "1px solid #eee" : "none",
              boxShadow:
                window.innerWidth <= 768
                  ? "0 -4px 16px rgba(0,0,0,0.15)"
                  : "none",
            }}
          >
            <InteractiveSearchUI
              handleIntractiveSearch={handleIntractiveSearch}
              setChatData={setChatData}
              jobType={jobTypes.ADDFILE}
              queryType={queryTypes.file}
            />
          </div>
        )}
      </div>

      {openModalView && (
        <SaveFilterModal
          openModalView={openModalView}
          onClose={() => setOpenModalView(false)}
          filters={filters}
          searchQuery={buildSearchQuery()}
          type={activeTab}
          projectId={currentProject?.id}
          fetchSavedFilters={fetchSavedFilters}
        />
      )}
    </>
  );
};

export default FileSearchInterface;
